import { Request } from '../request';

export const updateInsuranceSupport = (id: number, supportInsurance: boolean) => {
    return Request.put({ url: `/admin-server/klarity/page/insurance/support/update/${id}/${supportInsurance}` });
};

export const getAllSetInsurances = () => {
    return Request.get({ url: '/schedule-server/provider/uniprofile/insurances' });
};
